import React, { FC } from "react";

import styles from "./SubmitterRow.module.scss";

type Props = {
  fullName: string;
  count: number;
};

const SubmitterRow: FC<Props> = ({ fullName, count }) => (
  <li className={styles.row}>
    <span className={styles.name}>{fullName}</span>
    {count > 0 ? (
      <span className={styles.count}>{count}</span>
    ) : (
      <span className={styles.unsubmittedBadge}>未提出</span>
    )}
  </li>
);

export default SubmitterRow;
